import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { getEventTypes } from '@/apis/eventTypes';
import { labelSorting } from '@/util/labelSorting';

export const useEventTypes = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();
      return (await getEventTypes(token))
        .filter((x) => x.label.toLowerCase().includes(lookupValue.toLowerCase()))
        .sort(labelSorting);
    },
    [getAccessTokenSilently]
  );
};
